import React from 'react';
import classnames from 'classnames';

interface ValidationResult {
  success: boolean;
  message?: string;
}

interface TextInputProps {
  id?: string;
  type?: string;
  rows?: number;
  options?: unknown[];
  value?: string;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  validationResult?: ValidationResult;
  invalidLabel?: boolean;
  showInvalidLabel?: boolean;
  name?: string;
  className?: string;
  placeholder?: string;
  updateHandler?: (value: string, stateType?: string) => void;
  attrs?: Record<string, unknown>;
  stateType?: string;
  addon?: React.ReactNode;
}

const TextInput = ({
  onKeyDown,
  stateType,
  updateHandler,
  attrs = {},
  validationResult,
  invalidLabel,
  className,
  addon,
  type = 'Text',
  name,
  value,
  placeholder,
}: TextInputProps) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.keyCode === 13) {
      onKeyDown?.(e);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (stateType) {
      updateHandler?.(e.target.value, stateType);
    } else {
      updateHandler?.(e.target.value);
    }
  };
  let ErrorLabel;
  let inputClassName;
  if (validationResult && validationResult.success === false) {
    if (invalidLabel) {
      ErrorLabel = (
        <label className="invalid">{validationResult.message}</label>
      );
    }
    inputClassName = classnames(className, 'invalid');
  } else {
    inputClassName = className;
  }
  return (
    <div className="input-wrapper">
      {ErrorLabel}
      {addon}
      <input
        {...attrs}
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className={inputClassName}
        placeholder={placeholder}
      />
    </div>
  );
};

export default TextInput;
